import Immutable from 'seamless-immutable';
import ThemeModel from './theme-model';

/**
 * Transforms and array of backend theme objects into a ThemeCollection
 * @param {Object[]} themes - backend formatted themes
 * @returns {Theme[]}
 */
function deserialize(themes = []) {
  return Immutable(_.map(themes, ThemeModel.deserialize));
}

/**
 * Transforms a ThemeCollection into an array of backend theme objects
 * @param {Theme[]} themes
 * @returns {Object[]}
 */
function serialize(themes) {
  return _.map(themes, theme => ThemeModel.serialize(theme));
}

export default {
  create: deserialize,
  deserialize,
  serialize,
};
